import { Injectable } from '@angular/core'
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http'
import { Observable, throwError, empty } from 'rxjs'
import { HttpUrlEncodingCodec } from './../services/auth/encoder'
import { SecurityPortfolio } from '@models/security-portfolio.model'
import { PossibleValue } from '@models/possible-value.model'
import { environment } from '@env/environment'
import { ProfileManagerService } from '@app/custom-shared/services/profile-manager.service'
import { LocalService } from '@app/shared/services/local.service'
const BASE_PATH = environment.basePathExternal
const BASE_PATH_API = environment.basePathExternalApi
/**
 * Service class to communicate with the REST services
 */
@Injectable({
  providedIn: 'root',
})
export class SecurityPortfolioService {
  constructor(
    private secureStorage:LocalService,
    protected httpClient: HttpClient,
    protected encoder: HttpUrlEncodingCodec,
    private profileManagerService: ProfileManagerService,
    
  ) { }
  /**
   * Validate the integrity of all fields of the given SecurityPortfolio
   * @param {SecurityPortfolio} body
   * @returns {  Observable<any>}
   */
  getAvailablePosition(body?: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/operation/availablePosition`,
      body,
      { headers: headers }
    )
  }
  validate(body?: SecurityPortfolio): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/securityPortfolios/validate`,
      body,
      { headers: headers }
    )
  }
  /**
   * Export the selected elements with the givenFormat
   * @param {string} format
   * @param {string} keys
   * @param {string} criteria
   * @param {string} searchOrder
   * @param {SecurityPortfolio} body
   * @returns {  Observable<File>}
   */
  export(
    format?: string,
    keys?: string,
    criteria?: string,
    searchOrder?: string,
    body?: SecurityPortfolio[]
  ): Observable<any> {
    let params = new HttpParams({ encoder: this.encoder })
    if (format !== undefined && format !== null) {
      params = params.append('format', format.toString())
    }
    if (keys !== undefined && keys !== null) {
      params = params.append('keys', keys.toString())
    }
    if (criteria !== undefined && criteria !== null) {
      params = params.append('criteria', criteria.toString())
    }
    if (searchOrder !== undefined && searchOrder !== null) {
      params = params.append('searchOrder', searchOrder.toString())
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post(
      `${BASE_PATH}/securityPortfolios/export`,
      body,
      {
        params: params,
        headers: headers,
        observe: 'response',
        responseType: 'blob',
      }
    )
  }
  /**
   * Performs a search operation without pagination
   * @param {string} criteria
   * @param {string} order the order fields
   * @param {string} keys the chosen keys
   * @returns {  Observable<any[]>}
   */
  findAll(criteria?: string, order?: string, keys?: string): Observable<any[]> {
    let params = new HttpParams({ encoder: this.encoder })
    if (criteria !== undefined && criteria !== null) {
      params = params.append('criteria', criteria.toString())
    }
    if (order !== undefined && order !== null) {
      params = params.append('order', order.toString())
    }
    if (keys !== undefined && keys !== null) {
      params = params.append('keys', keys.toString())
    }
    return this.httpClient.get<any[]>(
      `${BASE_PATH}/SecurityPortfolioCtrl/eligibleList`,
      { params: params }
    )
  }
  findAllPtfConfiguration(): Observable<any[]> {
      return this.httpClient.get<any[]>(
        `${BASE_PATH_API}/getEligiblePTFConfigListByUser`,
       
      )
    }

    setCurrentPTFConfig(identifier): Observable<any> {
      let params = new HttpParams({ encoder: this.encoder })
      /* if (identifier !== undefined && identifier !== null) {
        params = params.append('identifier', identifier.toString())
      } */
      let body = {}
      //const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
      return this.httpClient.post<any>(
        `${BASE_PATH_API}/setCurrentPTFConfig?identifier=${identifier}`,body
      )
    }

 

  getEligibleSecurityPortfolioList() {
    return this.httpClient.get<any[]>(
      `${BASE_PATH}/securityPortfolios/getEligibleSecurityPortfolioList`
    )
  }
  /**
   * Find by the securityPortfolio identifiers
   * @param {number} id
   * @param {string} keys the required keys
   * @returns {Observable<SecurityPortfolio>}
   */
  findByCode(id?: number, keys?: string): Observable<SecurityPortfolio> {
    let params = new HttpParams({ encoder: this.encoder })
    if (id !== undefined && id !== null) {
      params = params.append('id', id.toString())
    }
    if (keys !== undefined && keys !== null) {
      params = params.append('keys', keys.toString())
    }
    return this.httpClient.get<SecurityPortfolio>(
      `${BASE_PATH}/securityPortfolios`,
      { params: params }
    )
  }
  /**
   * Saves the securityPortfolio
   * @param {SecurityPortfolio} body
   * @returns {Observable<SecurityPortfolio>}
   */
  insert(body?: SecurityPortfolio): Observable<SecurityPortfolio> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<SecurityPortfolio>(
      `${BASE_PATH}/securityPortfolios`,
      body,
      { headers: headers }
    )
  }
  /**
   * Updates the securityPortfolio
   * @param {SecurityPortfolio} body
   * @returns {Observable<SecurityPortfolio>}
   */
  update(body?: SecurityPortfolio): Observable<SecurityPortfolio> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.put<SecurityPortfolio>(
      `${BASE_PATH}/securityPortfolios`,
      body,
      { headers: headers }
    )
  }
  /**
   * Delete the instances having a code from the given list
   * @param {string} codes
   * @returns {  Observable<number>}
   */
  delete(codes?: string): Observable<number> {
    let params = new HttpParams({ encoder: this.encoder })
    if (codes !== undefined && codes !== null) {
      params = params.append('codes', codes.toString())
    }

    return this.httpClient.delete<number>(`${BASE_PATH}/securityPortfolios`, {
      params: params,
    })
  }
  /**
   * Returns the possible values of the given field
   * @param {string} field
   * @param {string} criteria
   * @param {SecurityPortfolio} body
   * @returns {  Observable<any[]>}
   */
  getPossibleValues(
    field: string,
    criteria?: string,
    body?: SecurityPortfolio
  ): Observable<any[]> {
    let params = new HttpParams({ encoder: this.encoder })
    if (criteria !== undefined && criteria !== null) {
      params = params.append('criteria', criteria.toString())
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any[]>(
      `${BASE_PATH}/securityPortfolios/${field}/possibleValues`,
      body,
      { params: params, headers: headers }
    )
  }
  /**
   * Returns the possible values of the given field translated using the current user profile
   * @param {string} field
   * @param {string} keys
   * @param {string} seperator
   * @param {string} criteria
   * @param {SecurityPortfolio} body
   * @returns {  Observable<any[]>}
   */
  getTranslatedPossibleValues(
    field: string,
    keys?: string,
    seperator?: string,
    criteria?: string,
    body?: SecurityPortfolio
  ): Observable<any[]> {
    let params = new HttpParams({ encoder: this.encoder })
    if (keys !== undefined && keys !== null) {
      params = params.append('keys', keys.toString())
    }
    if (seperator !== undefined && seperator !== null) {
      params = params.append('seperator', seperator.toString())
    }
    if (criteria !== undefined && criteria !== null) {
      params = params.append('criteria', criteria.toString())
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any[]>(
      `${BASE_PATH}/securityPortfolios/${field}/possibleValues/translated`,
      body,
      { params: params, headers: headers }
    )
  }
  /**
   * Find the securityPortfolio by code
   * @param {string} code
   * @param {string} keys the required keys
   * @returns {Observable<SecurityPortfolio>}
   */
  findByCodeAsString(
    code: string,
    keys?: string
  ): Observable<SecurityPortfolio> {
    let params = new HttpParams({ encoder: this.encoder })
    if (keys !== undefined && keys !== null) {
      params = params.append('keys', keys.toString())
    }
    return this.httpClient.get<SecurityPortfolio>(
      `${BASE_PATH}/securityPortfolios/${code}`,
      { params: params }
    )
  }
  /**
   * Deletes the securityPortfolio instance with the given code
   * @param {string} code
   * @returns {  Observable<any>}
   */
  deleteOne(code: string): Observable<any> {
    return this.httpClient.delete<any>(
      `${BASE_PATH}/securityPortfolios/${code}`
    )
  }
  /**
   * Deletes all securityPortfolios with an optional criteria
   * @param {string} criteria
   * @returns {  Observable<number>}
   */
  deleteWithCriteria(criteria?: string): Observable<number> {
    let params = new HttpParams({ encoder: this.encoder })
    if (criteria !== undefined && criteria !== null) {
      params = params.append('criteria', criteria.toString())
    }

    return this.httpClient.delete<number>(
      `${BASE_PATH}/securityPortfolios/delete`,
      { params: params }
    )
  }
  /**
   * Evaluates the given formula against the given securityPortfolio instance
   * @param {string} formula
   * @param {SecurityPortfolio} body
   * @returns {  Observable<any>}
   */
  evaluateFormula(formula?: string, body?: SecurityPortfolio): Observable<any> {
    let params = new HttpParams({ encoder: this.encoder })
    if (formula !== undefined && formula !== null) {
      params = params.append('formula', formula.toString())
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/securityPortfolios/evaluate`,
      body,
      { params: params, headers: headers }
    )
  }
  /**
   * Validate the integrity of the fieldName in the given securityPortfolio instance
   * @param {string} field
   * @param {SecurityPortfolio} body
   * @returns {  Observable<any>}
   */
  validateField(field: string, body?: SecurityPortfolio): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/securityPortfolios/${field}/validate`,
      body,
      { headers: headers }
    )
  }
  /**
   * Validate the integrity of all fields of the given SecurityPortfolio
   * @param {SecurityPortfolio} body
   * @returns {  Observable<any>}
   */
  validateAll(body?: SecurityPortfolio): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/securityPortfolios/validate/all`,
      body,
      { headers: headers }
    )
  }
  /**
   * The available formarts that can be used to export currencies
   * @returns {  Observable<any[]>}
   */
  getAvailableFormats(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${BASE_PATH}/securityPortfolios/export/availableFormats`
    )
  }
  /**
   * Refresh entity keys
   * @param {string} keys the keys to refresh
   * @param {SecurityPortfolio} body
   * @returns {Observable<SecurityPortfolio>}
   */
  refreshKeys(
    keys?: string,
    body?: SecurityPortfolio
  ): Observable<SecurityPortfolio> {
    let params = new HttpParams({ encoder: this.encoder })
    if (keys !== undefined && keys !== null) {
      params = params.append('keys', keys.toString())
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<SecurityPortfolio>(
      `${BASE_PATH}/securityPortfolios/refresh`,
      body,
      { params: params, headers: headers }
    )
  }
  /**
   * Counts all the securityPortfolios with an optional criteria
   * @param {string} criteria
   * @returns {  Observable<number>}
   */
  count(criteria?: string): Observable<number> {
    let params = new HttpParams({ encoder: this.encoder })
    if (criteria !== undefined && criteria !== null) {
      params = params.append('criteria', criteria.toString())
    }
    return this.httpClient.get<number>(
      `${BASE_PATH}/securityPortfolios/count`,
      { params: params }
    )
  }
  /**
   * Return a new securityportfolio instance initialized from the server
   * @returns {Observable<SecurityPortfolio>}
   */
  newInstance(): Observable<SecurityPortfolio> {
    return this.httpClient.get<SecurityPortfolio>(
      `${BASE_PATH}/securityPortfolios/new`
    )
  }
  /**
   * Performs a paginated search on securityPortfolios
   * @param {string} criteria
   * @param {string} order the order fields
   * @param {string} keys the chosen keys
   * @param {number} page the page number
   * @param {number} size the page size
   * @returns {  Observable<any[]>}
   */
  find(
    criteria?: string,
    order?: string,
    keys?: string,
    page?: number,
    size?: number
  ): Observable<any[]> {
    let params = new HttpParams({ encoder: this.encoder })
    if (criteria !== undefined && criteria !== null) {
      params = params.append('criteria', criteria.toString())
    }
    if (order !== undefined && order !== null) {
      if(order==""){
        params = params.append('order', "clientCode".toString())
      }
      else{
      params = params.append('order', order.toString())
    }
    }
    if (keys !== undefined && keys !== null) {
      params = params.append('keys', keys.toString())
    }
    if (page !== undefined && page !== null) {
      params = params.append('page', page.toString())
    }
    if (size !== undefined && size !== null) {
      params = params.append('size', size.toString())
    }
    return this.httpClient.get<any[]>(
      `${BASE_PATH}/securityPortfolios/search`,
      { params: params }
    )
  }
  /**
   * Saves the securityPortfolio
   * @param {SecurityPortfolio} body
   * @returns {Observable<SecurityPortfolio>}
   */
  save(body?: SecurityPortfolio): Observable<SecurityPortfolio> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<SecurityPortfolio>(
      `${BASE_PATH}/securityPortfolios/save`,
      body,
      { headers: headers }
    )
  }
  
fundPortolio(body?: any): Observable<any> {
  const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
  let bodytow = null
  let managerCode= null;
  let ptcCode = null;
  body={"managerCode" : null,"ptfCod":null}
  if (this.secureStorage.getJsonValue('portfolioCode')){
    let portfolioCode=JSON.parse(this.secureStorage.getJsonValue('portfolioCode'))
    if (this.profileManagerService.isMasterBO() || this.profileManagerService.isOperatorBO()){
      bodytow={"managerCode" : null,"ptfCod":null}
      
    }
    else{
      managerCode = portfolioCode.managerCode ? portfolioCode.managerCode : null;
     ptcCode = portfolioCode.portfolioCode ?portfolioCode.portfolioCode : null;
     bodytow={"managerCode" : managerCode,"ptfCod":ptcCode}

    }
    
    
  }
  return this.httpClient.get<any>(
    `${BASE_PATH_API}/getEligibalFundsperUser`,
    
    { headers: headers }
  )
}


}
